import {
  GuestInboxTimelineAttachment,
  GuestInboxTimelineEvent,
} from '@new/domains/operations/components/StayTimeline/StayTimeline.types'

export type AttachmentKind = 'image' | 'video' | 'file'

const IMAGE_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
const VIDEO_CONTENT_TYPES = ['video/mp4']

/** The line Spoke writes into the body for each file sent on a message. */
const PLACEHOLDER_LINE = /^\[sent an attachment(: .+)?\]$/

export const getAttachmentKind = ({
  contentType,
}: Pick<GuestInboxTimelineAttachment, 'contentType'>): AttachmentKind => {
  if (IMAGE_CONTENT_TYPES.includes(contentType)) return 'image'
  if (VIDEO_CONTENT_TYPES.includes(contentType)) return 'video'

  return 'file'
}

const KIND_ORDER: AttachmentKind[] = ['image', 'video', 'file']

export const sortByKind = <T>(items: T[], getKind: (item: T) => AttachmentKind) => {
  return items.toSorted((left, right) => {
    return KIND_ORDER.indexOf(getKind(left)) - KIND_ORDER.indexOf(getKind(right))
  })
}

export const getAttachmentName = ({ fileName }: Pick<GuestInboxTimelineAttachment, 'fileName'>) => {
  return fileName || 'Attachment'
}

const EXTENSION_BY_CONTENT_TYPE: Record<string, string> = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/heic': 'heic',
  'video/mp4': 'mp4',
  'video/3gpp': '3gp',
  'application/pdf': 'pdf',
}

export const getDownloadName = ({
  fileName,
  contentType,
}: Pick<GuestInboxTimelineAttachment, 'fileName' | 'contentType'>) => {
  return fileName || `attachment.${EXTENSION_BY_CONTENT_TYPE[contentType] ?? 'bin'}`
}

export const stripAttachmentPlaceholders = ({
  body,
  attachments,
}: Pick<GuestInboxTimelineEvent, 'body' | 'attachments'>) => {
  if (!attachments?.length) return body

  return body
    .split('\n')
    .filter(line => !PLACEHOLDER_LINE.test(line.trim()))
    .join('\n')
    .trim()
}
